import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteHeaderComponent } from './layouts/components/site-header/site-header.component';
import { SiteFooterComponent } from './layouts/components/site-footer/site-footer.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { TabsModule } from "ngx-bootstrap/tabs";
import { AlertComponent, AlertModule } from "ngx-bootstrap/alert";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TableModule } from "ngx-easy-table";
import { ModalModule } from "ngx-bootstrap/modal";
import { RouterModule } from "@angular/router";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { NgxPaginationModule } from "ngx-pagination";
import { NgxSpinnerModule } from "ngx-spinner";
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { XchangeCustomCheckboxComponent } from './form-control-components/xchange-custom-checkbox/xchange-custom-checkbox.component';
import { XchangeCustomRadioComponent } from './form-control-components/xchange-custom-radio/xchange-custom-radio.component';
import { XchangeSearchControlComponent } from './form-control-components/xchange-search-control/xchange-search-control.component';
import { ProductFeaturesComponent } from './product-features/product-features.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SidebarModule } from "@solidexpert/ng-sidebar";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { CarouselModule } from "ngx-owl-carousel-o";
import { AlertsComponent } from './components/alerts/alerts.component';
import { LoaderComponent } from './components/loader/loader.component';
import { AddAccessoriesLightboxComponent } from './components/add-accessories-lightbox/add-accessories-lightbox.component';
import { ProgressModalComponent } from './components/progress-modal/progress-modal.component';
import { HomeSearchComponent } from './components/home-search/home-search.component';
import { CreateReserveModalComponent } from './components/create-reserve-modal/create-reserve-modal.component';
import { ShareEmailModalComponent } from './components/share-email-modal/share-email-modal.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { SwitchTabModalComponent } from './components/switch-tab-modal/switch-tab-modal.component';
import { XchangeViewAllColorsComponent } from "./components/xchange-view-all-colors/xchange-view-all-colors.component";
import { AddUserModalComponent } from "./components/add-user-modal/add-user-modal.component";
import { CommentModalComponent } from './components/comment-modal/comment-modal.component';
import { BuilderDivisionComponent } from "./components/builder-modals/builder-division/builder-division.component";
import { BuilderSubdivisionComponent } from "./components/builder-modals/builder-subdivision/builder-subdivision.component";
import { GetBuilderInfoComponent } from "./components/builder-modals/get-builder-info/get-builder-info.component";
import { SubmitBuilderComponent } from "./components/builder-modals/submit-builder/submit-builder.component";
import { BuilderDetailsComponent } from './components/builder-modals/builder-details/builder-details.component';
import { SiteSidenavComponent } from "./layouts/components/site-sidenav/site-sidenav.component";
import { InfiniteScrollDirective } from "../shared/directives/infinite-scroll";
import { CaptchaComponent } from './components/captcha/captcha.component';
import { CustomIconComponent } from './components/custom-icon/custom-icon.component';
import { XchangeSearchInputComponent } from "./form-control-components/xchange-search-input/xchange-search-input.component";
import { ClaimLineTypeComponent } from "./components/claim-line-type/claim-line-type.component";
import { ClaimCommentsComponent } from './components/claim-comments/claim-comments.component';
@NgModule({
  declarations: [
    SiteHeaderComponent,
    SiteFooterComponent,
    MainLayoutComponent,
    ConfirmationDialogComponent,
    XchangeCustomCheckboxComponent,
    XchangeCustomRadioComponent,
    XchangeSearchControlComponent,
    ProductFeaturesComponent,
    AlertsComponent,
    LoaderComponent,
    AddAccessoriesLightboxComponent,
    ProgressModalComponent,
    HomeSearchComponent,
    CreateReserveModalComponent,
    ShareEmailModalComponent,
    ErrorModalComponent,
    SwitchTabModalComponent,
    AddUserModalComponent,
    XchangeViewAllColorsComponent,
    GetBuilderInfoComponent,
    BuilderDivisionComponent,
    BuilderSubdivisionComponent,
    SubmitBuilderComponent,
    BuilderDetailsComponent,
    CommentModalComponent,
    SiteSidenavComponent,
    InfiniteScrollDirective,
    CaptchaComponent,
    CustomIconComponent,
    XchangeSearchInputComponent,
    ClaimLineTypeComponent,
    ClaimCommentsComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule,
    TabsModule.forRoot(),
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TableModule,
    SidebarModule,
    CarouselModule,
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    NgxPaginationModule,
    NgxSpinnerModule,
    TypeaheadModule.forRoot(),
    ProgressbarModule.forRoot(),
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    AccordionModule.forRoot()
  ],
  exports: [
    NgSelectModule,
    TabsModule,
    AlertModule,
    BsDatepickerModule,
    TableModule,
    AccordionModule,
    SidebarModule,
    CollapseModule,
    ModalModule,
    PaginationModule,
    ConfirmationDialogComponent,
    ProductFeaturesComponent,
    CreateReserveModalComponent,
    CarouselModule,
    HomeSearchComponent,
    LoaderComponent,
    ShareEmailModalComponent,
    XchangeCustomCheckboxComponent,
    XchangeCustomRadioComponent,
    XchangeSearchControlComponent,
    InfiniteScrollDirective,
    XchangeSearchInputComponent
  ]
})
export class SharedModule { }
